<template>
  <div class="permissionsinfo">

    <template v-for="(item,index) in list">
    <div class="travel-box" v-if="item.content.length>0" :key="index">
      <div class="title">{{item.name}}</div>
      <div class="lists-box">
        <div class="items-box" v-for="(ele,idx) in item.content" :key="idx">
          <div class="titles">{{ele.name}}</div>
          <div class="desc">{{ele.content}}</div>
        </div>

      </div>
    </div>
    </template>

  </div>
</template>

<script>
    import { indexdesc } from '../../service/modules/index'
    export default {
        components: {},
        data () {
            return {
                list: [],
                authData: {}
            };
        },
        computed: {},
        watch: {},
        methods: {},
        mounted () {
            indexdesc().then(res => {
                this.authData = res.data
                this.list = JSON.parse(localStorage.getItem('authList'))
                for (let j = 0; j < this.list.length; j++) {
                    for (let i in this.authData) {
                        if (this.list[j].auth.indexOf(i) !== -1) {
                            this.list[j].content.push(this.authData[i])
                        }
                    }
                }
            })
        },

        created () {}
    };
</script>

<style scoped lang="less">
.permissionsinfo {
  width: 100%;
  min-height: 100%;
  background: #fbfbfb;
  padding-top: 16px;
  .back-box {
    height: 44px;
    position: relative;
    box-sizing: border-box;
    padding: 0 12px;
    background: #36b374;

    .text {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .back-icon {
      width: 10px;
      height: 16px;
      position: absolute;
      left: 20px;
      top: 14px;
    }
  }
  .travel-box:last-child{
    margin-bottom: 16px;
  }
  .travel-box {
    box-sizing: border-box;
    padding: 0 12px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
    }
    .lists-box {
      .items-box {
        box-sizing: border-box;
        padding: 16px 12px 12px 16px;
        background: #fff;
        border-bottom: 1px solid #eee;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-bottom: 16px;

        &:last-child {
          border-bottom: none;
        }

        .titles {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-bottom: 8px;
        }
        .desc {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 22px;
        }
      }
    }
  }
}
</style>
